import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import LoadingSpinner from "../../Components/spinner";
import { baseURL } from "../../services/axios/eps";

const SEOFormModal = ({
  show,
  onHide,
  onSubmit,
  initialValues,
  loading,
  isEdit,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const validationSchema = Yup.object().shape({
    page_name: Yup.string().required("Page Name is required"),
    page_code: Yup.string().required("Page Code is required"),
    meta_title: Yup.string().max(255, "Should not exceed 255 characters"),
    meta_description: Yup.string(),
    meta_keywords: Yup.string(),
  });

  useEffect(() => {
    if (show) {
      setSelectedFile(null);
      setPreviewUrl(null);
    }
  }, [show]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="nftg-modal">
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>
          {isEdit ? "Edit Page Metadata" : "Add Page Metadata"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={
            initialValues || {
              page_name: "",
              page_code: "",
              meta_title: "",
              meta_description: "",
              meta_keywords: "",
              og_image: "",
              status: 1,
            }
          }
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={(values) => onSubmit(values, selectedFile)}
        >
          {({ handleChange, handleSubmit, values, errors, touched }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formPageName">
                    <Form.Label className="text-secondary">Page Name</Form.Label>
                    <Form.Control
                      name="page_name"
                      value={values.page_name}
                      onChange={handleChange}
                      className="bg-dark text-light border-secondary"
                      isInvalid={touched.page_name && !!errors.page_name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.page_name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="formPageCode">
                    <Form.Label className="text-secondary">
                      Page Code (Unique Identifier)
                    </Form.Label>
                    <Form.Control
                      name="page_code"
                      value={values.page_code}
                      onChange={handleChange}
                      className="bg-dark text-light border-secondary"
                      isInvalid={touched.page_code && !!errors.page_code}
                      disabled={isEdit}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.page_code}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3" controlId="formMetaTitle">
                <Form.Label className="text-secondary">Meta Title</Form.Label>
                <Form.Control
                  name="meta_title"
                  value={values.meta_title}
                  onChange={handleChange}
                  className="bg-dark text-light border-secondary"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMetaDescription">
                <Form.Label className="text-secondary">
                  Meta Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="meta_description"
                  value={values.meta_description}
                  onChange={handleChange}
                  className="bg-dark text-light border-secondary"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMetaKeywords">
                <Form.Label className="text-secondary">
                  Meta Keywords (Comma separated)
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="meta_keywords"
                  value={values.meta_keywords}
                  onChange={handleChange}
                  className="bg-dark text-light border-secondary"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formOGImage">
                <Form.Label className="text-secondary">OG Image</Form.Label>
                {(previewUrl || (isEdit && initialValues?.og_image)) && (
                  <div className="mb-2">
                    <img
                      src={
                        previewUrl ||
                        `${baseURL}/uploads/file/${initialValues.og_image}`
                      }
                      alt="OG Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        borderRadius: "8px",
                      }}
                      className="border border-secondary"
                      crossOrigin="anonymous"
                    />
                  </div>
                )}
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="bg-dark text-light border-secondary"
                />
                <Form.Text className="text-muted">
                  Recommended size: 1200x630 pixels.
                </Form.Text>
              </Form.Group>

              <div className="d-flex justify-content-end mt-4">
                <Button variant="secondary" onClick={onHide} className="me-2">
                  Cancel
                </Button>
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading ? (
                    <LoadingSpinner size="sm" />
                  ) : isEdit ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default SEOFormModal;
